import React from 'react'
import Link from 'next/link'
import routes from '../../../config/routes'
import { getWalletToken, useSelector } from '../../../store'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { CurrencyEnum } from '../../../types/Currency'
import useLocale from '../../../hooks/useLocale'
import { useTranslation } from 'next-i18next'

interface BalanceDisplayProps {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

export default function BalanceDisplay({ onClick }: BalanceDisplayProps) {
  const { locale } = useLocale()
  const { t } = useTranslation('common')

  const token = useSelector(
    getWalletToken(
      process.env.NEXT_PUBLIC_MVX_EURC_ESDT_IDENTIFIER
        ? process.env.NEXT_PUBLIC_MVX_EURC_ESDT_IDENTIFIER
        : 'USDC-350c4e',
    ),
  )
  let formattedTokenBalance: string = formatCurrency(
    token ? Number(token.balance) : 0,
    2,
    token ? token.decimals : 0,
    CurrencyEnum.EUR,
    locale,
  )
  return (
    <Link
      href={{ pathname: routes.account, query: { tab: 'wallets' } }}
      onClick={onClick}
    >
      <div className="cursor-pointer rounded-md bg-purpleGradient transition-all duration-200 ease-in-out hover:shadow-lg">
        <div className="flex flex-col items-center px-3 py-1.5">
          <p className="text-[10px] leading-none text-white/75">
            {t('navbar.balance')}
          </p>
          <p className="mt-0.5 text-sm font-semibold leading-none text-white">
            {formattedTokenBalance}
          </p>
        </div>
      </div>
    </Link>
  )
}
